// extracted by mini-css-extract-plugin
module.exports = {"FooterItem":"style-module--FooterItem--10OD1","list":"style-module--list--37Rtj","title":"style-module--title--azUP4"};